import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from '../Services/i18n';

const LanguageSelector = () => {
    const { t } = useTranslation();

    const languages = [
        { code: 'en', flag: '🇬🇧', name: 'English' },
        { code: 'es', flag: '🇪🇸', name: 'Español' },
        { code: 'fr', flag: '🇫🇷', name: 'Français' },
        { code: 'pt', flag: '🇵🇹', name: 'Português' }
    ];

    const changeLanguage = (langCode) => {
        i18n.changeLanguage(langCode);
        // Update URL without reloading the page
        const url = new URL(window.location.href);
        url.searchParams.set('lang', langCode);
        window.history.pushState({}, '', url);
    };

    return (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '16px' }}>
            {languages.map((lang) => (
                <Tooltip key={lang.code} title={lang.name}>
                    <IconButton
                        onClick={() => changeLanguage(lang.code)}
                        style={{
                            backgroundColor: i18n.language === lang.code ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                            fontSize: '1.5rem',
                            padding: '8px'
                        }}
                    >
                        {lang.flag}
                    </IconButton>
                </Tooltip>
            ))}
        </div>
    );
};

export default LanguageSelector; 